<template>
  <div class="main_right hbl-class">
    <breadcrumb :breadcrumb="subConfig.breadcrumb" />
    <!--<bread-crumb :breadcrumb="subConfig.breadcrumb" />-->
    <text-title :mainTitle="subConfig.title[0]" :subheading="subConfig.title[1]" />
    <!--<title-bar :title="subConfig.title" />-->
    <!-- region表单 -->
    <div class="form" v-loading="loading">
      <!--suppress CommaExpressionJS -->
      <div :key="key" class="line"
           v-for="[key, mapping], index in keyMappingEntities"
      >
        <consume-content v-if="mapping.type === 'renderLabelAndContent'"
                         :data="data" :renderContent="mapping.renderContent"
                         pageType="create"
                         @change="val => void onChange(key, val)"
        />

        <template v-else>
          <!-- 提示标签 -->
          <span class="tip-label">
            <span class="color-red" v-if="mapping.nullable === false">*</span>
            {{mapping.label}}：
          </span>

          <div class="line">
            <!-- region 各种输入框 -->
            <template>
              <!-- region 日期选择器，范围 -->
              <el-date-picker v-if="mapping.type === 'date-range'" size="mini"
                              class="width-height-xxx"
                              v-model="data[`_${key}`]._value._value"
                              type="daterange" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              @change="val => void onChange(key, val)"
              >
              </el-date-picker>
              <!-- endregion 日期选择器，范围 -->
              <!-- endregion 日期选择器，单日 -->
              <el-date-picker v-else-if="mapping.type === 'date-ymd'" size="mini" :editable="false"
                              class="width-xxx" v-model="data[key]"
                              type="date" placeholder="选择日期"
                              @change="val => void onChange(key, val)"
              />
              <el-date-picker v-else-if="mapping.type === 'date-ymdhms'" size="mini" :editable="false"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              class="width-xxx date-ymdhms" v-model="data[key]"
                              type="datetime" placeholder="选择日期时间"
                              @change="val => void onChange(key, val)"
              />
              <!-- region 日期选择器，单月 -->
              <el-date-picker v-else-if="mapping.type === 'monthDate'" size="mini"
                              class="width-xxx" v-model="data[key]"
                              type="month" placeholder="选择日期"
                              value-format="yyyy-MM"
                              @change="val => void onChange(key, val)"
              />
              <!-- endregion 日期选择器，单月 -->
              <!-- region 日期选择器，单日 -->
              <el-date-picker v-else-if="mapping.type === 'date'" size="mini"
                              class="width-xxx"
                              v-model="data[key]"
                              type="date" placeholder="选择日期"
                              @change="val => void onChange(key, val)"
              >
              </el-date-picker>
              <!-- endregion 日期选择器，单日 -->

              <!-- region 下拉 输入框 -->
              <el-select v-else-if="mapping.type === 'list'" size="mini"
                         class="width-height-xxx"
                         :value="data[`_${key}`]._value && data[`_${key}`]._value._label"
                         :loading="data[`_${key}`].loading" :clearable="true"
                         @input="d => data[`_${key}`]._value = d"
                         @change="val => void onChange(key, val)"
              >
                <el-option v-for="item in data[`_${key}`].list"
                           :label="item._label" :value="item"
                           :key="item._value" :value-key="item._value" />
              </el-select>
              <!-- endregion 下拉 输入框 -->

              <!-- region 下拉输入框（远程） -->
              <el-select v-else-if="mapping.type === 'remote-fetch'"
                         size="mini"
                         filterable remote placeholder="请输入"
                         class="width-height-xxx"
                         :value="data[`_${key}`]._value && data[`_${key}`]._value._label"
                         :remote-method="query => mapping.remoteSearch(data, query)"
                         :loading="data[`_${key}`].loading"
                         @input="d => data[`_${key}`]._value = d"
                         @change="val => void onChange(key, val)"
                         @compositionstart.native="data[`_${key}`].composing = true"
                         @compositionend.native="data[`_${key}`].composing = false"
              >
                <el-option v-for="item in data[`_${key}`].list"
                           :label="item._label" :value="item"
                           :key="item._value" :value-key="item._value" />
              </el-select>
              <!-- endregion 下拉输入框（远程） -->

              <!-- region 树 -->
              <input-tree v-else-if="mapping.type === 'tree'"
                          class="width-height-xxx input-tree"
                          :fetch="mapping.fetchDetail"
                          :maxDepth="mapping.maxDepth"
                          :canChoose="mapping.canChoose"
                          :defaultValue="mapping.tree.getDefaultValue(data)"
                          @input="val => void onChange(key, val)" />
              <!-- endregion 树 -->

              <!-- region 图标上传 -->
              <icon-upload v-else-if="mapping.type === 'icon-upload'"
                           v-model="data[key]"
                           :uploadUrl="keyMappingOriginal[key].uploadUrl()" />
              <!-- endregion 图标上传 -->

              <!-- 自定义内容 -->
              <consume-content v-else-if="mapping.type === 'render'"
                               class="width-height-xxx" :data="data"
                               :renderContent="mapping.renderContent"
                               pageType="modify"
                               @change="val => void onChange(key, val)"
              />

              <transfer v-else-if="mapping.type === 'transfer'" @changeMeetingPlayers="val => data[key] = val" :modifyTransfer="data[key]" />

              <input
                v-else-if="mapping.type === 'label' || mapping.editable === false"
                type="text" disabled="disabled"
                class="input-normal width-height-xxx" title=""
                :value="data[key]"
              />

              <!-- region 文本域 -->
              <!--suppress JSUnresolvedVariable -->
              <el-input v-else-if="mapping.type === 'textarea'"
                        class="width-xxx"
                        type="textarea" :rows="2" v-model="data[key]"
                        @blur="handleValidate($event.target.value, key)"
              />
              <!-- endregion 文本域 -->
              <!-- region 普通输入框 -->
              <!--suppress JSUnresolvedVariable -->
              <input v-else class="input-normal width-height-xxx" type="text"
                     v-model="data[key]" title=""
                     @blur="handleValidate($event.target.value, key)"
              />
              <!-- endregion 普通输入框 -->
            </template>
            <!-- endregion 各种输入框 -->

            <!-- region 输入提示 -->
            <template v-if="messages[key]">
            <span v-if="messages[key].success === true"
                  class="el-icon-success tip-icon"></span>
              <span v-else :class="
                  ['tip', messages[key].success === false ? 'color-red' : 'color-blue-gray']
                  "
              >{{messages[key].message}}</span>
            </template>
            <!-- endregion 输入提示 -->
          </div>
        </template>
      </div>
      <div class="op-bar" style="margin-left: 128px; width: 333px;display: flex;justify-content: space-between">
        <el-button class="button primary" @click="modifyData">确定</el-button>
        <el-button class="button" @click="handleCancel">取消</el-button>
      </div>
    </div>
    <!-- endregion表单 -->
    <consume-content
      pageType="modify"
      :data="data"
      :renderContent="renderDialog"
    />
  </div>
</template>

<script>
import BreadCrumb from '../common/bread-crumb'
import diDingMixin from './di-ding-mixin'
import diDingValidateMixin from './di-ding-validate-mixin'
import TitleBar from '../common/title-bar'
import IconUpload from '../common/icon-upload'
import ConsumeContent from '../common/consume-content'
import InputTree from '../../inputs/input-tree'
import {diDingPostOrPatchMixin} from './di-ding-post-or-patch-mixin'
import {errorHandler, ifNullGenerateTipping} from '../../../../utils/errorHandler'
import Transfer from '../../transfer'
import Breadcrumb from '../../../Breadcrumb/Breadcrumb'
import TextTitle from '../../../Text/TextTitle'

export default {
  components: {
    TextTitle,
    Breadcrumb,
    Transfer,
    InputTree,
    IconUpload,
    TitleBar,
    BreadCrumb,
    ConsumeContent
  },
  name: 'di-ding-modify',
  mixins: [diDingMixin, diDingPostOrPatchMixin, diDingValidateMixin],
  computed: {
    subConfig () {
      return this.config.modify
    },
  },
  data () {
    return {
      data: {},
      loading: true,
      dataInConfig: {},
    }
  },
  created () {
    this.render()
  },
  methods: {
    render () {
      this.data = {}
      const {id} = this.$route.params
      this.initData()
      this.config.getCurrent(id)
        .then(ifNullGenerateTipping('未查询到收款账户'))
        .then(this.onDataLoaded)
        .then(this.fetchDetail)
        .catch(errorHandler('请求失败'))
        .then(this.loaded)
    },
    onDataLoaded (data) {
      data = Object.assign({}, this.data, data)
      this.keyMappingEntities.forEach(([, {onDataLoaded}]) => {
        onDataLoaded && onDataLoaded(data, 'modify')
      })
      this.data = data
    },
    modifyData () {
      this.patchData(this.data, this.handleCancel)
    },
    handleCancel () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  @import "./common";

  .generate-form-style();
  .generate-tip-style();
  .generate-op-bar-style();

</style>

<style lang="less">
  @import "./common";

  .generate-common-style();
  .line .el-input__prefix {
    display: inline!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/pages/modify.vue